// extracted by mini-css-extract-plugin
export default {"spinnerLoading":"wizardLayoutEmet_spinnerLoading__TVcrG"};